// Which open edit screens hold unsaved changes right now (TGCLOUD-1902), for
// the guards that sit outside them: a link out of the pedigree
// (useRouteLeaveGuard) asks about a record modal's changes as it does about a
// sidebar's. Module state, like store/workspace/unsavedWork.js, because the
// guards are read at the moment of a click and render nowhere near the forms.

const forms = new Map();

/** Record (or with 0, forget) how many changes the form `id` holds. */
export const setUnsavedFormCount = (id, count) => {
  if (Number.isFinite(count) && count > 0) forms.set(id, count);
  else forms.delete(id);
};

/** How many unsaved changes every open form holds together. */
export const getUnsavedFormCount = () =>
  [...forms.values()].reduce((sum, n) => sum + n, 0);

// For tests: module state outlives a render.
export const resetUnsavedForms = () => forms.clear();
